import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useToast } from '@eluve/components';

import { useGetFilePdfUrl } from './useGetFilePdfUrl';

export const AppointmentPdfPage: React.FC = () => {
  const toast = useToast();
  const { tenantId, appointmentId } = useParams() as {
    tenantId: string;
    appointmentId: string;
  };

  const handlePdf = useGetFilePdfUrl({
    appointmentId,
    tenantId,
    type: 'CHART',
  });

  useEffect(() => {
    (async () => {
      const response = await handlePdf();
      if (response.status === 201) {
        window.location.href = response.body.pdfUrl;
      } else {
        toast.error('Failed to generate PDF');
      }
    })();
  }, [handlePdf, toast]);

  return null;
};
